import styled from 'styled-components';

export const UnitTypeSearchContainer = styled.div`
  .col-sm-12 {
    padding: 0;
  }
`;
